module.exports = __webpack_public_path__ + "static/media/playground.25d0fddb.jpg";